import React from 'react';
import { Zap, Euro, MapPin, ShieldCheck } from 'lucide-react';
import { benefitsData } from '../data/mock';

const iconMap = {
  zap: Zap,
  euro: Euro,
  'map-pin': MapPin,
  'shield-check': ShieldCheck
};

const Benefits = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Pourquoi Choisir JYA ?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            La solution de recharge mobile la plus simple et abordable
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefitsData.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div 
                key={benefit.id}
                className="group p-8 rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-200 hover:border-yellow-300 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 bg-yellow-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-yellow-500 group-hover:scale-110 transition-all duration-300">
                  <Icon className="w-7 h-7 text-yellow-600 group-hover:text-white transition-colors duration-300" />
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
